import {
  FETCH_AUDIO_TRACKS,
  FETCH_AUDIO_TRACKS_SUCCESS,
  FETCH_AUDIO_TRACKS_FAILED,
  SAVE_AUDIO_TRACKS_TRANSCRIPT,
  SAVE_AUDIO_TRACKS_TRANSCRIPT_SUCCESS,
  SAVE_AUDIO_TRACKS_TRANSCRIPT_FAILED,
  FETCH_DASHBOARD,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILED,
  REGISTER,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  GET_COLLEGE_LIST,
  GET_COLLEGE_LIST_SUCCESS,
  GET_COLLEGE_LIST_FAILED,
} from "./../constants/constants";

const initialState = {
  audioList: {
    data: [],
    count: 0,
  },
  UserDashboard: {},
  Count: "",
  success: {
    message: "",
  },
  error: {
    message: "",
  },
  loading: false,
  collegeList: [],
};

const AudioToTrackReducer = (state = initialState, action) => {
  let { UserDashboard } = state;
  switch (action.type) {
    case REGISTER:
      return {
        ...state,
        loading: true,
        insert: false,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        insert: true,
        success: {
          message: "New user has been created. Please login now !!!. Your Password is PASS123.",
        },
      };
    case REGISTER_FAILED:
      return {
        ...state,
        loading: false,
        insert: false,
        error: {
          message: action.data.Statusdesc,
        },
      };

    case GET_COLLEGE_LIST:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case GET_COLLEGE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        collegeList: action.data || [],
      };
    case GET_COLLEGE_LIST_FAILED:
      return {
        ...state,
      };
    case FETCH_AUDIO_TRACKS:
      return {
        ...state,
        loading: true,
        // success:{
        //     message:''
        // },
        // error:{
        //     message:''
        // },
      };
    case FETCH_DASHBOARD:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DASHBOARD_SUCCESS:
      UserDashboard = action.data.data;
      return {
        ...state,
        UserDashboard,
      };
    case FETCH_DASHBOARD_FAILED:
      return {
        ...state,
      };
    case FETCH_AUDIO_TRACKS_SUCCESS:
      return {
        ...state,
        loading: false,
        audioList: action.data.data,
        Count: action.data.Count,
      };
    case FETCH_AUDIO_TRACKS_FAILED:
      return {
        ...state,
      };
    case SAVE_AUDIO_TRACKS_TRANSCRIPT:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case SAVE_AUDIO_TRACKS_TRANSCRIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: {
          message: "Transcipt updated successfully!",
        },
      };
    case SAVE_AUDIO_TRACKS_TRANSCRIPT_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          message: "Transcipt update failed",
        },
      };
    default:
      return state;
  }
};

export default AudioToTrackReducer;
